
<template>

<!-- <v-app id="app"></v-app> -->

<v-app id="app">
 <CoreToolbar></CoreToolbar> 
  <CoreDrawer></CoreDrawer> 
 <CoreView></CoreView> 
<AdminFooter></AdminFooter>
 <AdminOpciones> </AdminOpciones>
 </v-app>
</template>

<script>


import CoreDrawer from '@/components/common/Drawer';
import CoreToolbar from '@/components/common/Toolbar';

import CoreView from '@/components/common/View';

import AdminFooter from '@/components/common/AdminFooter';

import AdminOpciones from '@/components/common/AdminOpciones.vue';


export default {
  name: 'MenuAdmin',

  components: {
    CoreToolbar,
    CoreDrawer,
    CoreView,
    AdminFooter,
    AdminOpciones
  }
};




</script>
